<template>
        <v-list>
          <v-list-item
            v-for="item in serviceList ? serviceList : items"
            :key="item.service"
          >
            <v-list-item-content>
              <v-list-item-title v-html="item.service"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon :color="item.status ? 'green' : 'red'">cloud_circle</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
</template>
<script>
  export default {
    props: ['serviceList'],
    data () {
      return {
        items: [
          {service: '[no Data]'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ServicesHealthList.vue?d75f3c70